import "animate.css";
import Counter from "../../common/Counter";
import { STATS_DATA } from "../../constants/StatsConstant";
import React from "react";

const Stats = () => {
  return (
    <div className="home4-feature-area">
      <div className="container-fluid">
        <div className="row g-xl-4 gy-5">
          {/* Left Section */}
          <div
            className="col-xl-3 wow animate__animated animate__fadeInLeft"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <div className="section-title-4">
              <h2>Our Stats</h2>
              <p>
                We’ve built a track record rooted in performance, innovation,
                and measurable success—delivering results that speak louder than
                words.
              </p>
            </div>
          </div>
          {/* Right Section */}
          <div className="col-xl-9 d-flex justify-content-end">
            <div className="counter-area">
              <div className="row g-lg-0 gy-5">
                {STATS_DATA.map(
                  ({ id, icon, value, suffix, title, description, delay }) => (
                    <div
                      key={id}
                      className={`col-lg-3 col-sm-6 d-flex justify-content-center ${
                        id !== 1 ? "devider" : ""
                      } wow animate__animated animate__fadeInUp`}
                      data-wow-delay={delay}
                      data-wow-duration="1500ms"
                    >
                      <div className="single-counter">
                        <div className="icon">{React.createElement(icon)}</div>
                        <div className="content">
                          <div className="number">
                            <h3 className="counter">
                              <Counter end={value} />
                              {suffix && <span> {suffix} </span>}
                            </h3>
                            <span> {title} </span>
                          </div>
                          <p> {description} </p>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stats;
